module.exports = __webpack_public_path__ + "static/media/400062_02.5c8a5ae9.png";